import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import CloseButton from 'components/Common/CloseButton'
import { rem } from 'polished'
import cn from 'clsx'
import LayoutContainer from 'components/Common/LayoutContainer'
import HideLiveChat from 'components/Common/HideLiveChat'

const CloseCross = styled(CloseButton)`
  position: absolute;
  top: ${rem(8)};
  right: ${rem(8)};
`

const FilterDropdown = styled(LayoutContainer)`
  display: flex;
  padding: 0;
  flex-direction: column;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  visibility: hidden;
  width: 100vw;
  background-color: ${props => props.theme.palette.neutral.eight};
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate3d(-50%, 100%, 0);
  max-height: min(calc(var(--vh, 1vh) * 100 - 200px), 820px);
  border-radius: ${props => props.theme.borderRadius.medium};
  z-index: 3;

  &.visible {
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
  }

  &.offset {
    bottom: ${rem(-16)};
  }
`

interface Props {
  onClose?: (e) => void;
  open?: boolean;
  className?: string;
  offset?: boolean;
}

const OfferFilterFullSizeDropdown = React.forwardRef<HTMLDivElement, PropsWithChildren<Props>>((props, ref) => {
  const { className, offset, onClose, children, open } = props

  return (
    <FilterDropdown ref={ref} className={cn(className, { visible: open, offset })}>
      {onClose && <CloseCross onClick={onClose} />}
      {children}
      {open && <HideLiveChat />}
    </FilterDropdown>
  )
})

OfferFilterFullSizeDropdown.displayName = 'OfferFilterFullSizeDropdown'

export default React.memo(OfferFilterFullSizeDropdown)
